var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import * as React from 'react'; // tslint:disable-line
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
var cls = classNames('icon-label');
import styled, { css } from 'styled-components';
import { Icon } from './icon';
export var IconLabelSizes = {
  "inherit": 18,
  "large": 32,
  "medium": 18,
  "small": 18,
  "tiny": 18
};
export var IconLabelSpacing = {
  inherit: 2,
  tiny: 2,
  small: 2,
  medium: 2,
  large: 3
};
export var IconLabelFontWeights = {
  "inherit": 400,
  "large": 500,
  "medium": 400,
  "small": 400,
  "tiny": 400
};
export var IconLabelFontSizes = {
  "large": 18,
  "medium": 15,
  "small": 14,
  "tiny": 13
};
export var IconLabelDefaultProps = {
  size: 'small',
  reverse: false
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    line-height: 1.1em;\n    font-family: ", ";\n    color: ", ";\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    \n    ", "\n\n    ", "\n  "], ["\n    line-height: 1.1em;\n    font-family: ", ";\n    color: ", ";\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    \n    ", "\n\n    ", "\n  "])), theme.FONT('sans'), theme.COLOR('strong'), function (_a) {
    var _fontWeight = _a._fontWeight;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      font-weight: ", ";\n    "], ["\n      font-weight: ", ";\n    "])), _fontWeight);
  }, function (_a) {
    var _fontSize = _a._fontSize;
    return _fontSize && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      font-size: ", ";\n    "], ["\n      font-size: ", ";\n    "])), theme.FONT_SIZE(_fontSize));
  })
});
var IconStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\n    flex-shrink: 0;\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    \n  "], ["\n\n    flex-shrink: 0;\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    \n  "])), function (_a) {
    var hasText = _a.hasText,
      labelSize = _a.labelSize;
    return hasText && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      margin-right: ", ";\n    "], ["\n      margin-right: ", ";\n    "])), theme.UNIT(IconLabelSpacing[labelSize]));
  }, function (_a) {
    var hasText = _a.hasText;
    return !hasText && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      margin-right: 0;\n    "], ["\n      margin-right: 0;\n    "])));
  }, function (_a) {
    var reverse = _a.reverse,
      labelSize = _a.labelSize;
    return reverse && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      order: 2;\n      margin-right: 0;\n      margin-left: ", ";\n    "], ["\n      order: 2;\n      margin-right: 0;\n      margin-left: ", ";\n    "])), theme.UNIT(IconLabelSpacing[labelSize]));
  }, function (_a) {
    var hasText = _a.hasText;
    return !hasText && css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      margin-left: 0;\n    "], ["\n      margin-left: 0;\n    "])));
  })
});
var BodyStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var reverse = _a.reverse;
    return reverse && css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      order: 1;\n    "], ["\n      order: 1;\n    "])));
  })
});
// -------- Components -------->
var My = {
  Container: styled.span(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Icon: styled(Icon)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Body: styled.span.attrs(cls.attr('body'))(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles)
};
export var IconLabel = function (props) {
  var className = props.className,
    icon = props.icon,
    children = props.children,
    size = props.size,
    onClick = props.onClick,
    reverse = props.reverse;
  var fontSize = size !== 'inherit' && IconLabelFontSizes[size];
  var fontWeight = IconLabelFontWeights[size];
  var iconSize = props.iconSize || IconLabelSizes[size];
  var hasText = !!children;
  return React.createElement(My.Container, {
    role: onClick ? 'button' : 'aria-label',
    onClick: onClick,
    _fontWeight: fontWeight,
    _fontSize: fontSize,
    className: cls.name(className)
  }, icon && React.createElement(My.Icon, {
    reverse: reverse,
    labelSize: size,
    size: iconSize,
    hasText: hasText
  }, icon), React.createElement(My.Body, {
    reverse: reverse
  }, children));
};
IconLabel.defaultProps = IconLabelDefaultProps;
IconLabel.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;